import { render, staticRenderFns } from "./secondIndex.vue?vue&type=template&id=7c92e9c2&scoped=true&"
import script from "./secondIndex.vue?vue&type=script&lang=js&"
export * from "./secondIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92e9c2",
  null
  
)

export default component.exports